import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { FontWeight, Colors } from '../../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  fieldWrapper: {
    borderBottom: `1px solid ${Colors.Gray5}`,
    padding: '30px 0',
  },
  fieldContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  fieldText: {
    color: `${Colors.Blue} !important`,
    fontWeight: `${FontWeight.Bold} !important`,
  },
  inputWrapper: {
    minWidth: 117,
    marginLeft: '35px !important',
    textAlign: 'center',
  },
  input: {
    maxWidth: 117,
    display: 'block !important',
  },
  error: {
    fontWeight: FontWeight.Regular,
    fontSize: 14,
    marginTop: 5,
  },
  subLabel: {
    fontSize: 12,
    color: Colors.Gray6,
  },
}));

export default useStyles;